import {Component, DoBootstrap, Inject, Injector, NgModule, PLATFORM_ID} from '@angular/core';
import {BrowserModule, Meta, provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {HttpBackend, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {provideTranslateService, TranslateLoader, TranslatePipe} from '@ngx-translate/core';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';

import {environment} from '../environments/environment';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ShowHidePasswordComponent} from './components/show-hide-password/show-hide-password.component';
import {IonicStorageModule} from '@ionic/storage-angular';
import {SwiperModule} from 'swiper/angular';
import {HeaderModule} from "./components/header/header.module";
import {LeafPageModule} from "./pages/leaf/leaf.module";
import {ActionPointPageModule} from "./pages/action-point/action-point.module";
import {ProfileWebComponent} from "./components/profile-web/profile-web.component";
import {MyTeamsOrganisationsComponent} from "./components/my-teams-organisations/my-teams-organisations.component";
import {TeamListModule} from "./components/team-list/team-list.module";
import {CompaniesListModule} from "./components/companies-list/companies-list.module";
import {LoginSideComponent} from "./components/login-side/login-side.component";
import {LoggedOutHeaderModule} from "./components/logged-out-header/logged-out-header.module";
import {isPlatformBrowser} from "@angular/common";
import {ShareModalComponent} from "./modal/share-modal/share-modal.component";
import {ShareSelectModalComponent} from "./modal/share-select-modal/share-select-modal.component";
import {createCustomElement} from "@angular/elements";
import {TextModalComponent} from "./modal/text-modal/text-modal.component";
import {ImpactMapPageModule} from "./pages/impact-map/impact-map.module";
import {ImpactHeaderModule} from "./components/impact-header/impact-header/impact-header.module";

const linkToTranslations = `https://wunu.dev/planeed/i18n/${environment.name === 'demo' ? 'stage' : environment.name}/`;
export const createTranslateLoader = (http: HttpBackend, platformId: Object) => new MultiTranslateHttpLoader(
  http, [
    {prefix: isPlatformBrowser(platformId) ? './assets/i18n/' : linkToTranslations, suffix: '.json'},
    {
      prefix: linkToTranslations,
      suffix: '.json'
    }
  ]
);


@Component({
    selector: 'app-span-with-text',
    template: `<span>{{ text }}</span>`,
    styles: [`
    span {
      color: blue;
      font-weight: bold;
    }
  `],
    standalone: false
})
export class SpanWithText {
  text: string = `Hello, I am a Web Component!`;
}

@NgModule({
  declarations: [
    AppComponent,
    ShowHidePasswordComponent,
    ProfileWebComponent,
    MyTeamsOrganisationsComponent,
    LoginSideComponent,
    ShareModalComponent,
    ShareSelectModalComponent,
    SpanWithText,
    TextModalComponent,
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    SwiperModule,
    HeaderModule,
    LeafPageModule,
    ActionPointPageModule,
    TeamListModule,
    CompaniesListModule,
    LoggedOutHeaderModule,
    ImpactMapPageModule,
    ImpactHeaderModule, TranslatePipe
  ], providers: [
    provideTranslateService({
      fallbackLang: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpBackend, platformId: Object) => createTranslateLoader(http, platformId),
        deps: [HttpBackend, PLATFORM_ID]
      }}),
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true,
    })),
    provideHttpClient(withFetch()),
    Meta,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule implements DoBootstrap {


  constructor(@Inject(PLATFORM_ID) private platformId: object, private injector: Injector) {
    if (isPlatformBrowser(this.platformId)) {
      const el = createCustomElement(SpanWithText, {injector});
      customElements.define('app-span-with-text', el);
    }
  }

  ngDoBootstrap() {
  }
}
